import React from 'react';
import { Service } from '../models/service.model';
import services from './services';

const getUniqueId = (() => {
	var id = 0;
	return () => `id-${id++}`;
})();

export { getUniqueId };

export function split(input: string): Array<any> {
	let arr: Array<React.ReactNode | string> = input.split('/');

	arr = arr.map((value, index) => {
		return (index > 0) ? [<br key={String(value)} />, value] : value;
	});
	return (arr.flat());
}

export function addNewline(input: string): JSX.Element[] {
	return input.split('\\n').map(str => {
		return <i key={str}>{str}</i>;
	});
}

export function deepCopy(obj: { [key: string]: any } | Array<any>): Object | Array<any> {
	if (obj instanceof Array) {
		let newArr = [];
		for (var item of obj) {
			if (typeof item != 'object') {
				newArr.push(item);
			} else newArr.push(deepCopy(item));
		}
		return newArr;
	}

	if (typeof obj == 'object') {
		let newObj: { [key: string]: any } = {};
		var field: string;

		for (field in obj) if (obj.hasOwnProperty(field)) {
			if (typeof obj[field] != 'object') {
				newObj[field] = obj[field];
			} else newObj[field] = deepCopy(obj[field]);
		}
		return newObj;
	}
	return obj;
}

export function priceFormat(number: number): string {
	return parseFloat(String(number)).toFixed(0)
		.replace(/(\d)(?=(\d{3})+\.)/g, '$1 ') + ' ₽';
}

export function getTeethText(teeth: number): string {
	var text;
	switch (Number(teeth)) {
		case 1: text = teeth + " зуба"; break;
		case 2: case 3: case 4: case 5: case 6: case 7: case 8:
		case 9: text = teeth + " зубов"; break;
		case 10: text = teeth + " и более зубов"; break;
		case 14: text = "зубов 1 челюсти"; break;
		case 28: text = "зубов 2 челюстей"; break;
		default: text = 'none';
	}
	return text;
}

export function jawsText(jaws: number): string {
	switch (Number(jaws)) {
		case 1: return '1 челюсть';
		case 2: return '2 челюсти';
		default: return '';
	}
}

export function sendPostMessage({ type, payload }: { [key: string]: any }) {
	try {
		window?.top?.postMessage(JSON.stringify({ access: 'dentolo', type, payload }), '*');
	} catch (e) {
	}
}

export function getQueryParam(param: string) {
	var name = param.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
	var results = regex.exec(window.location.search);
	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export function defineInstallment(p: string, installment?: number): string {
	return p.replace(/%I\{(.*?)\}/g, installment ? "$1" : "");
}

export function setBold(p: string): JSX.Element[] | string {
	const boldText = p.match(/%b\{(.*?)\}/g);
	if (!boldText) return p;

	const result = p.split(' ').map(str => {
		if (str.match(/%b\{(.*?)\}/)) return <b key={str}>{str.replace(/%b\{(.*?)\}/, '$1')} </b>;
		else return <>{str} </>;
	})

	return result;
}

export function getWeightedRandom<T extends { weight: number }>(list: T[]): T | undefined {
	const sumOfWeights: number = list.reduce((sum, current) => current.weight + sum, 0);
	const randomRange: number = getRandomInt(1, sumOfWeights);
	let counter: number = 0;

	const desiredVariant = list.find(variant => {
		counter += variant.weight;
		if (counter >= randomRange) return variant;
		return undefined;
	});

	return desiredVariant;
}

export function getRandomInt(min: number, max: number): number {
	return Math.floor(min + Math.random() * (max + 1 - min));
}

export function getServiceName(service: Service | 'selection') {
	try {
		let name: string = services[service].name;
		name = name.replace('/', ' и ');
		return name.charAt(0).toUpperCase() + name.slice(1);
	} catch (err) {
		return 'Выбор направлений';
	}
}

export function scrollToTop() {
	try {
		window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	} catch (err) {
		if (err instanceof TypeError) {
			window.scrollTo(0, 0)
		} else {
			throw err;
		}
	}
}

export function pause(millseconds: number) {
	return new Promise(resolve => setTimeout(resolve, millseconds));
}